import { React } from "react";
const Siniestralidad2025 = ({ nombre, mdstatus, eseditable }) => {
    return(
        <div className=" w-full h-full">
        <iframe title="siniestralidad" className=" w-full h-full border-0"
       src="https://docs.google.com/spreadsheets/d/1IrEkwQZWZvQ67GOvcViuxrTMfP8nJOZ4yInUyGyOQJs/edit?gid=1974006085#gid=1974006085 "
        allowfullscreen sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox single=true;widget=true;headers=false"></iframe></div>
    )
}
export default Siniestralidad2025;